<template lang="pug">
  .edit-payment
    y-dialog(fill-height fluid v-model="showModal" scrollable :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" persistent max-width="600px")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text Payment history
        v-card-text.pa-0
          v-simple-table(fixed-header dark)
            template(v-slot:default)
              thead
                tr
                  th.text-left.s2.primary400--text(:style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }") Date
                  th.text-left.s2.primary400--text(:style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }") Method
                  th.text-left.s2.primary400--text(:style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }") Amount
                  th.text-left.s2.primary400--text(:style="{ 'background-color': $vuetify.theme.themes[$theme].basic200 }")
              tbody.basic100
                tr(v-for="(payment, index) in payments" :key="payment.id")
                  td.py-2
                    div.p2.default--text {{ payment.paid_date | displayDate }}
                  td.py-2
                    div.p2.default--text {{ payment.payment_method }}
                  td.py-2
                    div.p2.default--text {{ payment.amount | displayPrice }}
                  td.py-2
                    div.button-Aa-small.info500--text.clickable(@click="clickEditPayment(index)") Edit 
    .modals
      EditPayment(v-if="openEditPaymentDialog" :open.sync="openEditPaymentDialog" :parentPayment="editPayment" :parentExpense.sync="expense" @payment-edited="$emit('edited', $event)")     

</template>

<script>
import EditPayment from '@/components/yezzabook/dialogs/expense/EditPayment.vue'

export default {
  name: 'PaymentListDialog',
  props: ['open', 'payments', 'parentExpense'],
  components: { EditPayment },
  data: () => ({
    openEditPaymentDialog: false,
    editPayment: null
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    expense: {
      get() {
        return this.parentExpense
      },
      set(newValue) {
        this.$emit('update:parentExpense', newValue)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickEditPayment (index) {
      this.editPayment = this.payments[index]
      this.openEditPaymentDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .clickable {
    cursor: pointer;
  }
  tbody tr:hover {
    background-color: transparent !important;
  }
  .theme--dark.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--dark.v-data-table tbody tr td,
  .theme--dark.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
    border-bottom: 1px solid var(--v-basic300) !important;
  }
</style>

<i18n>
{
  "en": {
    "price": {
      "label": "Amount",
      "placeholder": "0"
    },
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>
